import { createApp } from 'vue'
import VucutKitleIndeksi from './VucutKitleIndeksi.vue'
import './assets/global.css'

createApp(VucutKitleIndeksi).mount('#vucut-kitle-indeksi')
